import { setToken, setTokenExpiration } from "./utils";
import { BASE_URL } from "./endpoints";

const authLogin = async (username: string, password: string) => {
  const data = {
    user_name: username,
    password,
  };

  let valid = false;
  let loginResult;

  try {
    const response = await fetch(`${BASE_URL}/api/auth/login`, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    loginResult = await response.json();
    valid = loginResult.success && loginResult.auth_token != null;
  } catch (except) {
    valid = false;
  }

  if (!valid) {
    if (
      loginResult &&
      loginResult.error &&
      loginResult.error.user_authentication
    ) {
      return {
        valid: false,
        message: loginResult.error.user_authentication,
      };
    }

    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }
  setToken(loginResult.auth_token);
  setTokenExpiration(loginResult.token_expiration);
  return {
    valid: true,
    auth_token: loginResult.auth_token,
  };
};

export default authLogin;
